<template>
    <span v-if="inputLine" class="text-left">cklaassen.github.io&euro; {{ content.join('') }}</span>
    <Help v-else-if="content.split(' ')[0] === 'help'" :arg="content"/>
    <Info v-else-if="content === 'info'" />
    <LS v-else-if="content === 'ls'" />
    <span v-else-if="typeof content === 'object' && content[0] === 'echo'" class="text-left">{{ content[1] }}</span>
    <span v-else class="text-left">{{ content }}</span>
</template>

<script>
import Help from '@/components/commands/Help.vue'
import Info from '@/components/commands/Info.vue'
import LS from '@/components/commands/LS.vue'

export default {
  name: 'Terminal',
  components: {
    Help,
    Info,
    LS
  },
  props: {
    content: {
      type: [String, Array],
      required: true
    },
    inputLine: {
      type: Boolean,
      required: true
    }
  },
  created: function () {
    console.log(this.content)
  }
}
</script>
